/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CryptoJS from 'crypto-js'
 
const AuthLoader = ({
  text = 'Insurelogist Platform Launcher',
  colorGradient = ['#001ec8', '#365796', '#1fbe97', '#2b9e3a'],
  size = 36,
  background = 'rgba(255,255,255,0.95)',
  duration = 3,
  gap = 0,
  barWidth = 700
}) => {
  const letters = Array.from(text)
  const navigate = useNavigate()
  const location = useLocation()
  const { lang } = useParams()
 
  const [errorState, setErrorState] = useState(null)
  const SECRET_KEY = '1234'
 
  // Inject animations
  useEffect(() => {
    const styleEl = document.createElement('style')
    document.head.appendChild(styleEl)
    const sheet = styleEl.sheet
 
    const keyframes = [
      `@keyframes hf-flip {
        0% { transform: perspective(400px) rotateX(0); }
        50% { transform: perspective(400px) rotateX(180deg); }
        100% { transform: perspective(400px) rotateX(0); }
      }`,
      `@keyframes gradient-shift {
        0% { background-position: 0% 50%; }
        100% { background-position: 200% 50%; }
      }`
    ]
 
    keyframes.forEach(rule => sheet.insertRule(rule, sheet.cssRules.length))
 
    return () => document.head.removeChild(styleEl)
  }, [])
 
  // Auto login
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const encryptedData = params.get('data')
    
    if (!encryptedData) return
 
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY)
      const creds = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
        console.log("bytes",creds);
        
      setTimeout(() => {
        onSubmit(creds.appId, creds.token)
      }, 1000)
    } catch (err) {
      console.error('Decryption failed', err)
    }
  }, [])

  const authorizeUser = async ({ appId, token }) => {
    
    if (!appId || !token) return null
    
    try {
        const base = process.env.REACT_APP_PUBLIC_AUTHENTICATION
    
        if (!base) {
        console.error('ENV missing: AUTHENTICATION BASE URL')
        return null
        }
    
        const endpoint = `${base}/access-control/user-role/user/${appId}/`
        const decryptPoint = `${base}/access-control/decrypt-app-id/${appId}/`
    
        // 1️⃣ Get user + role
        const res = await fetch(endpoint, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
        })
    
        if (!res.ok) {
        console.error('User role fetch failed', res.status)
        return null
        }
    
        const data = await res.json()
        if (!data.success) return null
    
        // 2️⃣ Decrypt app id
        const decryptRes = await fetch(decryptPoint, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
        })
    
        if (!decryptRes.ok) return null
    
        const decryptData = await decryptRes.json()
        const user = data.data.user
    
        return {
        id: user?.id,
        email: user?.email,
        name: `${user?.first_name ?? ''} ${user?.last_name ?? ''}`.trim() || 'N/A',
        role: data?.data?.role,
        role_name: data?.data?.role_name,
        appid: decryptData?.data?.decrypted_app_id,
        appId,
        token
        }
    } catch (err) {
        console.error('Authorize crashed:', err)
        return null
    }
    }
 
  const onSubmit = async (appId, token) => {
    const user = await authorizeUser({ appId, token })
    
    if (!user) {
        setErrorState({ message: ['Authentication failed'] })
        return
    }
    
    // ✅ Store session (same as next-auth session.user)
    sessionStorage.setItem('token', user.token)
    sessionStorage.setItem('appId', user.appId)
    sessionStorage.setItem('appid', user.appid)
    sessionStorage.setItem('role', user.role)
    sessionStorage.setItem('role_name', user.role_name)
    sessionStorage.setItem('user', JSON.stringify(user))
    
    // ✅ Redirect
    navigate(`/dashboard`)
    }
 
  const gradientCSS = `linear-gradient(120deg, ${colorGradient.join(', ')})`
 
  return (
<div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background,
        zIndex: 9999
      }}
>
<div style={{ textAlign: 'center' }}>
<div style={{ display: 'flex', gap }}>
            {letters.map((ch, idx) => {
            const delay = (idx * 0.12).toFixed(2)
 
            return (
              <span
                key={idx}
                style={{
                  display: 'inline-block',
                  fontWeight: 700,
                  fontSize: size,
                  lineHeight: 1,
                  textTransform: 'uppercase',
                  backgroundImage: gradientCSS,
                  backgroundSize: '200% 200%',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  color: 'transparent',
                  animation: `hf-flip ${duration}s cubic-bezier(.2,.9,.2,1) infinite, gradient-shift 3s linear infinite`,
                  animationDelay: `${delay}s, 0s`
                }}
              >
                {ch === ' ' ? '\u00A0' : ch}
              </span>
            )
          })}
</div>
 
        <div
          style={{
            width: barWidth,
            height: 8,
            marginTop: 12,
            borderRadius: 99,
            backgroundImage: gradientCSS,
            animation: 'gradient-shift 4s linear infinite'
          }}
        />
</div>
</div>
  )
}
 
export default AuthLoader